import { render, staticRenderFns } from "./ArticleGroup.vue?vue&type=template&id=ef20071e&"
import script from "./ArticleGroup.vue?vue&type=script&lang=js&"
export * from "./ArticleGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports